export const BBCORDERMANAGE_FILE = 'BBCORDERMANAGE_FILE';
// 更新
export const BBCORDERMANAGE_UPDATE = 'BBCORDERMANAGE_UPDATE';
